import React, { lazy, Suspense, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Helmet } from "react-helmet";
import "./App.css";

// Layout Components
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import WhatsAppCTA from "./components/common/WhatsAppCTA";
import GoogleAnalytics from "./components/analytics/GoogleAnalytics";

// Pages
import MentoringHome from "./pages/MentoringHome";

const About = lazy(() => import("./pages/About"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const Contact = lazy(() => import("./pages/Contact"));
const FAQ = lazy(() => import("./pages/FAQ"));
const Services = lazy(() => import("./pages/services/Services"));
const ServiceDetail = lazy(() => import("./pages/services/ServiceDetail"));
const Beasiswa = lazy(() => import("./pages/beasiswa/Beasiswa"));
const BeasiswaDetail = lazy(() => import("./pages/beasiswa/BeasiswaDetail"));

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
    } else {
      setTimeout(() => {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          const reduceMotion = window.matchMedia(
            "(prefers-reduced-motion: reduce)",
          ).matches;
          element.scrollIntoView({
            behavior: reduceMotion ? "auto" : "smooth",
          });
        }
      }, 100);
    }
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <GoogleAnalytics />
      <div className="app">
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            Mentoring Beasiswa Dalam &amp; Luar Negeri | #PintarPilihKuliah
          </title>
          <meta
            name="description"
            content="Program mentoring beasiswa untuk Indonesia, Asia Pasifik, Timur Tengah, Eropa, atau semua wilayah. Temukan peluang dan siapkan pendaftaran lebih terarah."
          />
          <link rel="canonical" href="https://pintarpilihkuliah.com/" />
        </Helmet>

        <Navbar />

        <main className="app-content">
          <Suspense
            fallback={
              <div className="page-loading" role="status">
                Memuat halaman...
              </div>
            }
          >
            <Routes>
              <Route path="/" element={<MentoringHome />} />
              <Route path="/tentang-kami" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/layanan/:serviceId" element={<ServiceDetail />} />
              <Route path="/beasiswa" element={<Beasiswa />} />
              <Route path="/beasiswa/:slug" element={<BeasiswaDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/kontak" element={<Contact />} />
              <Route path="*" element={<MentoringHome />} />
            </Routes>
          </Suspense>
        </main>

        <WhatsAppCTA />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
